import { api } from '../api.js';

/**
 * 租户管理API
 */
export const tenantAPI = {
    /**
     * 注册页可选租户（公开接口）
     */
    getRegisterOptions: () => api.get('/tenants/register-options'),

    /**
     * 当前用户可访问的租户（本租户 + 子租户；平台 admin 为全量）
     */
    getAccessible: () => api.get('/tenants/accessible'),

    /**
     * 获取所有租户
     */
    getAll: () => {
        return api.get('/tenants');
    },

    /**
     * 根据ID获取租户
     */
    getById: (id) => {
        return api.get(`/tenants/${id}`);
    },

    /**
     * 根据编码获取租户
     */
    getByCode: (tenantCode) => {
        return api.get(`/tenants/code/${tenantCode}`);
    },

    /**
     * 根据名称获取租户
     */
    getByName: (tenantName) => {
        return api.get(`/tenants/name/${tenantName}`);
    },

    /**
     * 开通租户（租户 + 默认组织 + 可选管理员）
     */
    provision: (data) => {
        return api.post('/tenants/provision', data);
    },

    /**
     * 租户开通摘要
     */
    getProvisionSummary: (id) => {
        return api.get(`/tenants/${id}/provision-summary`);
    },

    /**
     * 自助开通申请列表（平台审核）
     */
    listProvisionApplications: (params = {}) => api.get('/tenant-provision-applications', { params }),

    approveProvisionApplication: (id, reviewComment) =>
        api.post(`/tenant-provision-applications/${id}/approve`, { reviewComment }),

    rejectProvisionApplication: (id, reviewComment) =>
        api.post(`/tenant-provision-applications/${id}/reject`, { reviewComment }),

    submitProvisionApplication: (payload) => api.post('/tenant-provision-applications', payload),

    listMyProvisionApplications: () => api.get('/tenant-provision-applications/mine'),

    cancelProvisionApplication: (id) => api.post(`/tenant-provision-applications/${id}/cancel`, {}),

    /**
     * 创建租户
     */
    create: (data) => {
        return api.post('/tenants', data);
    },

    /**
     * 更新租户
     */
    update: (id, data) => {
        return api.put(`/tenants/${id}`, data);
    },

    /**
     * 删除租户
     */
    delete: (id) => {
        return api.delete(`/tenants/${id}`);
    },

    /**
     * 获取子租户列表
     */
    getSubTenants: (id) => {
        return api.get(`/tenants/${id}/sub-tenants`);
    },

    /**
     * 获取所有子租户（递归）
     */
    getAllSubTenants: (id) => {
        return api.get(`/tenants/${id}/all-sub-tenants`);
    },

    /**
     * 获取租户树结构
     */
    getTenantTree: (id) => {
        return api.get(`/tenants/${id}/tree`);
    },

    /**
     * 根据租户类型获取租户列表
     */
    getByType: (tenantType) => {
        return api.get(`/tenants/type/${tenantType}`);
    },

    /**
     * 获取根租户列表
     */
    getRootTenants: () => {
        return api.get('/tenants/root');
    },

    /**
     * 根据租户路径获取租户
     */
    getByPath: (tenantPath) => {
        return api.get(`/tenants/path/${tenantPath}`);
    },

    /**
     * 获取租户的所有上级租户
     */
    getParentTenants: (id) => {
        return api.get(`/tenants/${id}/parents`);
    },

    /**
     * 移动租户到新的父租户下
     */
    moveTenant: (id, newParentTenantId) => {
        return api.put(`/tenants/${id}/move`, null, {
            params: { newParentTenantId }
        });
    },

    /**
     * 批量创建租户
     */
    createBatch: (data) => {
        return api.post('/tenants/batch', data);
    },

    /**
     * 获取租户统计信息
     */
    getStatistics: (id) => {
        return api.get(`/tenants/${id}/statistics`);
    },

    /**
     * 获取租户已开通的页面权限
     */
    getPagePermissions: (tenantId) => api.get(`/tenants/${tenantId}/page-permissions`),

    /**
     * 平台管理员为租户分配页面权限
     */
    assignPagePermissions: (tenantId, permissionIds) =>
        api.put(`/tenants/${tenantId}/page-permissions`, { permissionIds })
}; 